const isNestedTo = (source, target) =>
  source.items.length &&
  source.items.some((item) => {
    if (item.id === target.id) {
      return true;
    }

    return item.items ? isNestedTo(item, target) : false;
  });

export default isNestedTo;
